export const USER_ORDER_TYPE = {
  APPLY: {
    label: '회원 신청 기본',
    key: 'APPLY'
  },
  USER: {
    label: '회원 정보 기본',
    key: 'USER'
  },
  REMAIN_DAY_DESC: {
    label: '잔여일 내림차순',
    key: 'REMAIN_DAY_DESC'
  },
  REMAIN_DAY_ASC: {
    label: '잔여일 오름차순',
    key: 'REMAIN_DAY_ASC'
  }
};
export const USER_ORDER = {
  PAID: {
    label: '유료',
    key: 'PAID'
  },
  FREE: {
    label: '무료',
    key: 'FREE'
  },
  EXPIRE: {
    label: '만료',
    key: 'EXPIRE'
  },
  BLOCK: {
    label: '중지',
    key: 'BLOCK'
  },
  WITHDRAW: {
    label: '탈퇴',
    key: 'WITHDRAW'
  }
};
export const PUSH_TYPE = {
  GENERAL: {
    label: '일반',
    key: 'GENERAL'
  },
  PURCHASE_POPUP: {
    label: '이용권 구매 팝업',
    key: 'PURCHASE_POPUP'
  },
  CALL_LIST: {
    label: '전화 리스트',
    key: 'CALL_LIST'
  },
  LOGIN: {
    label: '로그인',
    key: 'LOGIN'
  }
};
export const FILE_TARGET_TYPE = {
  REGISTRATION_CERT: {
    label: '대부업 등록증',
    key: 'REGISTRATION_CERT'
  }
};
export const TICKET_STATUS = {
  USING: {
    label: '이용중',
    key: 'USING'
  },
  EXPIRE: {
    label: '만료',
    key: 'EXPIRE'
  }
};
export const ORDER_TYPE = {
  LATEST: {
    label: '최신순',
    key: 'LATEST'
  },
  NAME: {
    label: '이름순',
    key: 'NAME'
  }
};
export const COLLECTION_STATUS = {
  COLLECTION: {
    label: '수집',
    key: 'COLLECTION'
  },
  STOP: {
    label: '중지',
    key: 'STOP'
  }
};
export const HISTORY_TYPE = {
  CALL: {
    label: '전화',
    key: 'CALL'
  },
  SMS: {
    label: '문자',
    key: 'SMS'
  }
};
export const EXISTS_TYPE = {
  ID: {
    label: '아이디',
    key: 'ID'
  },
  NICK: {
    label: '닉네임',
    key: 'NICK'
  },
  VERIFICATION: {
    label: '본인인증 정보 CI',
    key: 'VERIFICATION'
  },
  DEVICE_ID: {
    label: '기기 정보',
    key: 'DEVICE_ID'
  },
  PHONE: {
    label: '휴대폰 번호',
    key: 'PHONE'
  }
};
export const EXISTS_PATH = {
  ID: {
    label: '아이디',
    key: 'ID'
  },
  NICK: {
    label: '닉네임',
    key: 'NICK'
  }
};
export const BANNER_VIEW_TYPE = {
  LIST: {
    label: '리스트',
    key: 'LIST'
  },
  DETAIL: {
    label: '상세',
    key: 'DETAIL'
  }
};
export const BOARD_TYPE = {
  NOTICE: {
    label: '공지사항',
    key: 'NOTICE'
  }
};
export const COMPLAINT_STATUS = {
  PENDING: {
    label: '대기',
    key: 'PENDING'
  },
  DELETE: {
    label: '삭제',
    key: 'DELETE'
  },
  STOP: {
    label: '중지',
    key: 'STOP'
  }
};
export const RECEIVE_TYPE = {
  INCOMING: {
    label: '수신',
    key: 'INCOMING'
  },
  OUTGOING: {
    label: '발신',
    key: 'OUTGOING'
  },
  CANCEL: {
    label: '거절',
    key: 'CANCEL'
  },
  MISSED: {
    label: '부재중',
    key: 'MISSED'
  },
  UNRECEIVED: {
    label: '미수신',
    key: 'UNRECEIVED'
  }
};
export const RESET_TYPE = {
  DEVICE: {
    label: '기기',
    key: 'DEVICE'
  },
  PHONE: {
    label: '휴대폰',
    key: 'PHONE'
  },
  PASSWORD: {
    label: '비밀번호',
    key: 'PASSWORD'
  }
};
export const DEVICE_TYPE = {
  ANDROID: {
    label: '안드로이드',
    key: 'ANDROID'
  }
};
export const JOIN_TYPE = {
  GENERAL: {
    label: '일반',
    key: 'GENERAL'
  }
};
export const ROLE = {
  ROLE_USER: {
    label: '사용자',
    key: 'ROLE_USER'
  },
  ROLE_ADMIN: {
    label: '관리자',
    key: 'ROLE_ADMIN'
  },
  ROLE_SUPER: {
    label: '슈퍼관리자',
    key: 'ROLE_SUPER'
  }
};
export const APPLY_STATUS = {
  PENDING: {
    label: '대기',
    key: 'PENDING'
  },
  SUCCESS: {
    label: '완료',
    key: 'SUCCESS'
  },
  REJECT: {
    label: '거절',
    key: 'REJECT'
  }
};
export const APPROVE_STATUS = {
  PENDING: {
    label: '승인대기',
    key: 'PENDING'
  },
  APPROVE: {
    label: '승인',
    key: 'APPROVE'
  },
  REJECT: {
    label: '승인불가',
    key: 'REJECT'
  }
};

export const STATUS = {
  ACTIVE: {
    label: '활성',
    key: 'ACTIVE'
  },
  BLOCK: {
    label: '정지',
    key: 'BLOCK'
  },
  WITHDRAW: {
    label: '탈퇴',
    key: 'WITHDRAW'
  },
  INACTIVE: {
    label: '비활성',
    key: 'INACTIVE'
  },
  DELETED: {
    label: '삭제',
    key: 'DELETED'
  }
};
